import { motion } from 'framer-motion'

const gradients = {
  solar: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
  space: 'linear-gradient(135deg, #00D4FF 0%, #A855F7 100%)',
  energy: 'linear-gradient(135deg, #00FF88 0%, #00D4FF 100%)',
  land: 'linear-gradient(135deg, #8B4513 0%, #D2691E 100%)',
  air: 'linear-gradient(135deg, #00D4FF 0%, #4A90D9 100%)',
  satellite: 'linear-gradient(135deg, #A855F7 0%, #6366F1 100%)'
}

export default function GradientText({
  children,
  gradient = 'solar',
  as: Component = 'span',
  className = '',
  animate = false,
  ...props
}) {
  const style = {
    background: gradients[gradient],
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    display: 'inline-block'
  }

  if (animate) {
    return (
      <motion.span
        className={className}
        style={{
          ...style,
          backgroundSize: '200% 200%'
        }}
        animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'linear'
        }}
        {...props}
      >
        {children}
      </motion.span>
    )
  }

  return (
    <Component className={className} style={style} {...props}>
      {children}
    </Component>
  )
}
